// import { PayrollWCBWSIBEarningsList } from "components/PayrollWCBWSIBEarnings";
import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { PayrollWCBWSIBEarningList } from "../../components/PayrollWCBWSIBEarningList/PayrollWCBWSIBEarningList";

export interface IPayrollWCBWSIBEarningsListPage {}

export const PayrollWCBWSIBEarningsListPage: FC<
	IPayrollWCBWSIBEarningsListPage
> = (props: IPayrollWCBWSIBEarningsListPage) => {
	return (
		<AuthenticatedLayout
			pageTitle="Payroll WCBWSIB Earnings"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<PayrollWCBWSIBEarningList />}
		/>
	);
};
